import { render, staticRenderFns } from "./TankBar.vue?vue&type=template&id=08c451ee&scoped=true&"
import script from "./TankBar.vue?vue&type=script&lang=js&"
export * from "./TankBar.vue?vue&type=script&lang=js&"
import style0 from "./TankBar.vue?vue&type=style&index=0&id=08c451ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c451ee",
  null
  
)

export default component.exports